import { Container, Sprite, type Texture } from "pixi.js";
import { Spine, type SkeletonData } from "@esotericsoftware/spine-pixi-v8";
import { SpriteText, SpriteTextFitMode, WinAmountLabelSpineExplosion } from "@slot/presentation";
import type { SpineDriver, SpriteFontDefinition } from "@slot/presentation";

/**
 * Builds one `GridSymbolWinAmountLabel` (the prefab's tree): a black glow plate at alpha 181/255, the
 * golden-font sprite text (fit 680×216, 45 chars) and the `number_explosion` Spine the digits are
 * socketed to. `WinHighlightEffect` calls this per label and destroys the result.
 */
export function createWinAmountLabelFactory(input: {
  glowTexture: Texture | null;
  font: SpriteFontDefinition;
  explosionSkeleton: SkeletonData | null;
  spineDriver: SpineDriver;
}): () => WinAmountLabelSpineExplosion {
  return () => {
    const root = new Container({ label: "GridSymbolWinAmountLabel" });
    if (input.glowTexture) {
      const glow = new Sprite({ texture: input.glowTexture, anchor: 0.5, tint: 0x000000, alpha: 181 / 255 });
      glow.width = 893.3;
      glow.height = 420.8;
      root.addChild(glow);
    }
    const spriteText = new SpriteText({
      font: input.font,
      maxCharacters: 45,
      glyphScale: 1,
      fitMode: SpriteTextFitMode.Both,
      boxWidth: 679.9,
      boxHeight: 215.9,
      label: "SpriteTextLabel",
    });
    root.addChild(spriteText);
    let skeleton: Spine | null = null;
    if (input.explosionSkeleton) {
      skeleton = new Spine({ skeletonData: input.explosionSkeleton, autoUpdate: false });
      skeleton.label = "explosion";
      input.spineDriver.attach(skeleton);
      root.addChild(skeleton);
    }
    return new WinAmountLabelSpineExplosion({ node: root, spriteText, skeleton });
  };
}
